import {ConfEnv} from "../../../config/config";
import publicRequest from "../../../Infra/http/public.request";

export const hotGamesService = async () => {
  return await publicRequest.get(`${ConfEnv.BASE_URL_WALLET}/v1/public/hot-games`);
};
